/** Shared manual-billing instructions until automated payment is live. */
export type ManualBillingConfig = {
  /** When true, Billing shows the manual / contact flow instead of online checkout. */
  enabled: boolean;
  /**
   * When true, hide QR Ph, checkout, and self-serve reference forms.
   * Customers email support for payment instructions.
   */
  contactOnly: boolean;
  supportEmail: string;
  bankName: string;
  accountName: string;
  accountNumber: string;
  gcashNumber: string;
  gcashName: string;
  mayaNumber: string;
  mayaName: string;
  /** Short heading on the Billing payment panel. */
  heading: string;
  /** Numbered steps shown to the customer. */
  steps: readonly string[];
  /** Extra note under the steps. */
  notes: string;
};

export const defaultManualBilling: ManualBillingConfig = {
  enabled: true,
  contactOnly: true,
  supportEmail: 'billing@trieon.tech',
  bankName: 'Update bank name',
  accountName: 'Update account name',
  accountNumber: '0000-0000-0000',
  gcashNumber: '09XX XXX XXXX',
  gcashName: 'TrieonHR',
  mayaNumber: '09XX XXX XXXX',
  mayaName: 'TrieonHR',
  heading: 'Payment instructions',
  steps: [
    'Email billing support with your company name and subscription plan.',
    'Our team will send payment instructions for your invoice.',
    'Once payment is confirmed, your subscription is activated or renewed.',
  ],
  notes:
    'Please include your company code or invoice number when available. Online payment in the portal is currently in progress.',
};
